import {
  AItoolsmenu,
  studyAssistantsAndChatbots,
} from "../../../constants/library";
import { Backtotop, Floatinmenu, Underline,AI_tools_part_two } from "../../../widgets";
import "../../Library/AI_bots.css";
import { RadialMenu } from "../../../components";
import { FaMicrochip } from "react-icons/fa";

export default function Studyassistants() {

    return (
        <>
      <div className="librarypage">
            <div className="librarybg">
                <div className="libraryheading">AI - Tools</div>
                <div className="library_sub_heading">Study Assistants and Chatbots</div>
            </div>
        </div>
        <section className="librarydark">
            <div className="dept_float_menu">
                <Floatinmenu logo={FaMicrochip} head="Menu" links={AItoolsmenu} />
            </div>
            <RadialMenu menu_links={AItoolsmenu} />
            <Underline heading="Study Assistants and Chatbots" />
            <div  style={{ display: 'flex', flexWrap: 'wrap' }}>
                 {studyAssistantsAndChatbots.map((tool, index) => (
        <AI_tools_part_two key={index} {...tool} />
      ))}
            </div>
        </section>
        <Backtotop />

        </>
    )
}